<template>
  <main class="main">
    <section class="not-found section">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-delay="100">
            <div class="error-code-wrapper mb-4">
              <h1 class="error-code">404</h1>
              <div class="error-code-decoration"></div>
            </div>
            <h2 class="error-title mb-3">Page Not Found</h2>
            <p class="error-description mb-4">
              Oops! The page you're looking for seems to have wandered off into the digital void. 
              Don't worry, we'll help you find your way back.
            </p>
          </div>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-lg-8">
            <div class="error-content" data-aos="fade-up" data-aos-delay="200">
              <div class="error-actions mb-5">
                <router-link to="/" class="btn btn-primary btn-lg me-3">
                  <i class="bi bi-house-door me-2"></i>
                  Go to Homepage
                </router-link>
                <button @click="goBack" class="btn btn-outline-primary btn-lg">
                  <i class="bi bi-arrow-left me-2"></i>
                  Go Back
                </button>
              </div>

              <div class="quick-links-card">
                <h3 class="quick-links-title mb-4">
                  <i class="bi bi-compass me-2"></i>
                  Quick Links
                </h3>
                <div class="row g-4">
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="300">
                    <router-link to="/about" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-info-circle"></i>
                      </div>
                      <h4>About Us</h4>
                      <p>Learn more about MatrixHub</p>
                    </router-link>
                  </div>
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="400">
                    <router-link to="/services" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-briefcase"></i>
                      </div>
                      <h4>Our Services</h4>
                      <p>Explore what we offer</p>
                    </router-link>
                  </div>
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="500">
                    <router-link to="/products" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-box-seam"></i>
                      </div>
                      <h4>Our Products</h4>
                      <p>Discover our solutions</p>
                    </router-link>
                  </div>
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="300">
                    <router-link to="/team" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-people"></i>
                      </div>
                      <h4>Our Team</h4>
                      <p>Meet the experts</p>
                    </router-link>
                  </div>
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="400">
                    <router-link to="/contact" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-envelope"></i>
                      </div>
                      <h4>Contact Us</h4>
                      <p>Get in touch</p>
                    </router-link>
                  </div>
                  <div class="col-md-4" data-aos="fade-up" data-aos-delay="500">
                    <router-link to="/privacy-policy-page" class="quick-link-item">
                      <div class="quick-link-icon">
                        <i class="bi bi-shield-check"></i>
                      </div>
                      <h4>Privacy Policy</h4>
                      <p>Read our policy</p>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'NotFoundView',
  setup() {
    const router = useRouter();
    
    const goBack = () => {
      if (window.history.length > 1) {
        router.go(-1);
      } else {
        router.push('/');
      }
    };

    return {
      goBack
    };
  }
});
</script>
